import { el, unmount } from 'redom';

import EventPeriodDisplay from './period';
import EventBodyContainer from './body';
import EventCTAButton from './cta-button';

class EventDisplay {

  constructor(event, mode, alreadyRegistered) {

    this.eventPeriodDisplay = new EventPeriodDisplay(event);
    this.eventBodyContainer = new EventBodyContainer(event);
    this.eventCTAButton = new EventCTAButton(event, mode, alreadyRegistered);

    this.eventPeriodDisplayEl = el('.event-date-time-container', this.eventPeriodDisplay);
    this.eventItemBodyEl = el('.event-item-body', this.eventBodyContainer);
    this.eventCTAButtonContainerEl = el('.event-control-container', this.eventCTAButton);

    this.el = el('div.event-item-card', [this.eventPeriodDisplayEl, this.eventItemBodyEl, this.eventCTAButtonContainerEl]);

  }

  onunmount() {

    unmount(this.eventItemBodyEl, this.eventBodyContainer);
    unmount(this.eventPeriodDisplayEl, this.eventPeriodDisplay);
    unmount(this.eventCTAButtonContainerEl, this.eventCTAButton);

  }

}

export default EventDisplay;